interface DashboardHeaderProps {
    currentDate: string;
  }
  
  export function DashboardHeader({ currentDate }: DashboardHeaderProps) {
    return (
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Dashboard</h1>
          <p className="text-muted-foreground">Welcome back! Here's your performance overview.</p>
        </div>
        <div className="text-right">
          <p className="text-sm text-muted-foreground">Today</p>
          <p className="text-lg font-semibold text-foreground">{currentDate}</p>
        </div>
      </div>
    );
  }